import styled from 'styled-components';
import { capitalize, isEmpty } from 'lodash';
import { useUserSettingsSelector } from '../../../redux/selectorHooks';
import { getEntityHelpLink } from '../DictionaryTabs/utils';
import { EntityTabType } from '../DictionaryTabs/types';
import { DefaultView } from '../../../utils/userSettings';
import NoDataPlaceholder from '../../NoDataPlaceholder';

interface IProps {
  entityTabType: EntityTabType;
  searchTerm: string;
}

const StyledNoDataPlaceholder = styled(NoDataPlaceholder)`
  padding: 24px 12px;
`;

const QuickAccessDictionaryNoResults = ({
  entityTabType,
  searchTerm,
}: IProps) => {
  const defaultView = useUserSettingsSelector('defaultView');

  if (!isEmpty(searchTerm)) {
    return (
      <StyledNoDataPlaceholder iconSize={24} message={'No results found'} />
    );
  }

  const message =
    defaultView === DefaultView.ManagedView
      ? `Your schema has no ${capitalize(entityTabType)} in the Managed View.
    Click below to learn more about adding ${capitalize(entityTabType)} to a managed view. `
      : `Your schema has no ${capitalize(entityTabType)}.
    Click below to learn more about adding ${capitalize(entityTabType)}. `;

  return (
    <StyledNoDataPlaceholder
      iconSize={24}
      message={message}
      link={getEntityHelpLink(entityTabType, defaultView)}
    />
  );
};

export default QuickAccessDictionaryNoResults;
